import React, { useState } from 'react';

const Head = () => {
    const [isPaused, setIsPaused] = useState(false); // State for controlling animation pause
  
    const handleMouseEnter = () => {
      setIsPaused(true); // Pause the animation when mouse enters
    };
  
    const handleMouseLeave = () => {
      setIsPaused(false); // Resume the animation when mouse leaves
    };
  
    return (
      <div className="head">
        <div
          className={`scrolling-text ${isPaused ? 'paused' : ''}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Professor (Dr) R.K.Sharma (Former Director & Ex HOD Nephrology & Renal Transplantation, Sanjay Gandhi PGIMS, Lucknow) 40 years in the field of kidney disease, Transplantation Dialysis in AIIMS SGPGI
        </div>
      </div>
    );
  };
  
  export default Head;